<template>
  <div style="margin-top: 50px">
    <mt-header title="工单列表"> </mt-header>
    <!-- 查询工具栏 -->
    <div class="seach">
      <mt-search style="width: 100%; height: 50px" v-model="query.queryString"
        @keyup.enter.native="querySubmit"></mt-search>
    </div>
    <!-- 记录列表-->
    <scroll-body style="margin-top: 10px" :minheight="200" :outheight="180" :isScroll="true" @resize="resize">
      <template slot="content">
        <ul class="telitem infinite-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading"
          infinite-scroll-distance="10" :style="bodyStyle">
          <li v-for="(item, index) in data.psts" :key="index" class="infinite-list-item">
            <mt-cell :title="item.title" :label="item.pstSource.replace('红网', '') +
              ' ' +
              item.transferUnitName +
              ' ' +
              item.timeIntervalString +
              ' ' +
              appApi.getStatusTransferTitle(item.status)
              " is-link @click.native="detail(item.id)" />
          </li>
        </ul>
      </template>
    </scroll-body>
  </div>
</template>

<script>
import ScrollBody from "@/components/ScrollBody.vue";
export default {
  components: {
    ScrollBody,
  },
  beforeRouteLeave(to, from, next) {
    this.saveStore();
    next(); // 继续后续的导航解析过程
  },
  created() {
    this.pstApi.setWindowTitle("工单列表");
    this.getUnits(); //读取所有单位信息
    if (this.$store.state.pstQuery) {
      this.query = this.$store.state.pstQuery.query;
      //this.xpagination = this.$store.state.pstQuery.xpagination;
    }
    // console.log(this.query)
    // console.log(this.xpagination)
    //this.getWebsiteParameter();
    this.getPstList(); //读取分页信息
  },
  mounted() {
    // 将vue实例的方法绑定到window对象中去
    // window.problemShow = this.problemShow;
    // window.extensionShow = this.extensionShow;
  },
  data() {
    return {
      //数据项
      data: {
        units: [], //单位数据
        psts: [], //舆情信息
      },
      //搜索栏数据
      query: {
        unitId: "00000000-0000-0000-0000-000000000000", //单位信息
        pstType: -1, //类别
        categorys: [-2, 0, 1, 2, 3], //状态
        // categorys: [], //状态
        queryString: "", //模糊字段
        isSubmit: 1,
      },
      //分页查询参数
      xpagination: {
        totalCount: 1,
        pageSize: 10,
        currentPage: 1,
        totalPages: 1,
      },
      loading: false,
      //
      mouseStatus: {
        current: 0,
        seen: false,
      },
      bodyStyle: {
        overflowY: "auto",
        overflowX: "hidden",
        listStyle: "none",
        height: 420 + "px",
      },
    };
  },
  methods: {
    saveStore() {
      this.$store.commit("setPstQuery", {
        query: this.query,
        xpagination: this.xpagination,
      });
    },
    //查询方法部分
    querySubmit() {
      this.xpagination.currentPage = 1;
      this.getPstList();
    },
    getUnits() {
      this.data.units = [
        {
          id: "00000000-0000-0000-0000-000000000000",
          name: "所有单位",
        },
      ];
      this.userApi.getUnitAll().then((res) => {
        var data = res.data;
        this.data.units = this.data.units.concat(data);
      });
    },
    getPstList() {
      //保存store
      this.saveStore();
      //查询
      this.appApi
        .getPstList(
          this.query.unitId,
          this.query.pstType,
          this.query.categorys,
          this.query.queryString,
          this.xpagination.currentPage,
          this.xpagination.pageSize,
          this.query.isSubmit
        )
        .then((res) => {
          var data = res.data;
          this.data.psts = data;
          //console.log(data);
          var pagin = JSON.parse(res.headers.xpagination);
          //console.log(pagin)
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.currentPage = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        })
        .catch((error) => {
          this.$toast("读取失败");
        });
    },
    loadMore() {
      console.log('loadMore')
      // 判断是否到了最大页数，已是最大页数则不继续加载数据
      if (this.xpagination.currentPage >= this.xpagination.totalPages) {
        return;
      }

      this.xpagination.currentPage++;
      this.loading = true;

      this.pstApi
        .getPstList(
          this.query.unitId,
          this.query.pstType,
          this.query.categorys,
          this.query.queryString,
          this.xpagination.currentPage,
          this.xpagination.pageSize,
          this.query.isSubmit
        )
        .then((res) => {
          this.loading = false;
          let last = res.data;
          if (last) {
            this.data.psts = this.data.psts.concat(last);
          }
          var pagin = JSON.parse(res.headers.xpagination);
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.currentPage = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        });
    },
    detail(pstId) {
      //保存store
      this.saveStore();
      //调用详情
      this.$router.push({ name: "Details", params: { id: pstId } });
    },
    //
    enter(index) {
      this.mouseStatus.current = index;
      this.mouseStatus.seen = true;
    },
    leave() {
      this.mouseStatus.current = null;
      this.mouseStatus.seen = true;
    },
    resize(height) {
      this.bodyStyle.height = height - 10 + "px";
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.mint-cell {
  min-height: 60px;
}

/deep/.mint-cell-wrapper {
  font-size: 15px;
}

/deep/.mint-cell-value {
  font-size: 12px;
}
</style>